import {
  SHOW_NOTIFICATION,
} from './types/NotificationActionTypes';

export const showNotification = ({ message, type, duration = 5 }) => ({
  type: SHOW_NOTIFICATION,
  payload: {
    notification: { message, type, duration },
  },
});
